import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const PENDING_ORDER_TTL_MS = 15 * 60 * 1000;

const store = new Vuex.Store({
    state: {
        username: null,
        userRole: null,
        clientId: null,
        balanceText: null,
        pendingOrder: null
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    mutations: {
        logout(state) {
            state.username = null;
            state.userRole = null;
            state.clientId = null;
            state.balanceText = null;
            state.pendingOrder = null;
        },
        setUsername(state, username) {
            state.username = username;
        },
        setUserRole(state, userRole) {
            state.userRole = userRole;
        },
        setClientId(state, clientId) {
            state.clientId = clientId;
        },
        setBalanceText(state, balanceText) {
            state.balanceText = balanceText;
        },
        setPendingOrder(state, payload) {
            // Geriye dönük uyumluluk: payload doğrudan clientId (number/string) olabilir.
            const isObject = payload && typeof payload === 'object';
            const clientId = isObject ? payload.clientId : payload;
            const prefillAmount = isObject && payload.prefillAmount != null
                ? payload.prefillAmount
                : null;

            state.pendingOrder = {
                clientId: clientId,
                prefillAmount: prefillAmount,
                expiresAt: Date.now() + PENDING_ORDER_TTL_MS
            };
        },
        clearPendingOrder(state) {
            state.pendingOrder = null;
        },
        consumePendingOrderPrefill(state) {
            if (state.pendingOrder) {
                state.pendingOrder = {
                    ...state.pendingOrder,
                    prefillAmount: null,
                };
            }
        },
    }
});

export default store;